interface DonutChartProps {
  segments: { label: string; pct: number; color: string }[];
  size?: number;
  thickness?: number;
  centerLabel?: string;
  centerValue?: string;
}

export default function DonutChart({
  segments,
  size = 180,
  thickness = 26,
  centerLabel,
  centerValue,
}: DonutChartProps) {
  let acc = 0;
  const stops = segments.map((s) => {
    const start = acc;
    acc += s.pct;
    return `${s.color} ${start}% ${acc}%`;
  });
  const gradient = `conic-gradient(${stops.join(", ")})`;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <div
        className="h-full w-full rounded-full"
        style={{ background: gradient }}
      />
      <div
        className="absolute flex flex-col items-center justify-center rounded-full bg-white"
        style={{ inset: thickness }}
      >
        {centerValue && (
          <span className="text-2xl font-bold text-ghasla-text-heading">{centerValue}</span>
        )}
        {centerLabel && (
          <span className="mt-0.5 text-xs text-ghasla-text-secondary">{centerLabel}</span>
        )}
      </div>
    </div>
  );
}